/* ===========================================================
   LIENS THERMIQUES — Dragon d'Airain
   Étincelles pendant la transition de hover uniquement.
   =========================================================== */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---- Palette de chaleur ---- */
  var SPARK_COLORS = ['#ffb060', '#ff9040', '#ffd090', '#e8c074', '#ff7828', '#ffda9a'];

  /* ---- Pool de sparks réutilisables (évite les malloc répétés) ---- */
  var pool = [];

  function getSpark() {
    var s = pool.pop() || document.createElement('span');
    s.className = 'adda-spark';
    document.body.appendChild(s);
    return s;
  }

  function releaseSpark(s) {
    if (s.parentNode) s.parentNode.removeChild(s);
    s.style.cssText = '';
    pool.push(s);
  }

  /* ---- Émission d'une seule étincelle ---- */
  function emitOne(originX, originY, delay) {
    setTimeout(function () {
      var s = getSpark();

      var size  = 2 + Math.random() * 2.5;          /* 2–4.5 px        */
      var color = SPARK_COLORS[Math.floor(Math.random() * SPARK_COLORS.length)];

      /* Direction : surtout vers le haut avec dispersion latérale */
      var angle  = -Math.PI * 0.5 + (Math.random() - 0.5) * Math.PI * 0.9;
      var speed  = 38 + Math.random() * 55;          /* px/s            */
      var vx     = Math.cos(angle) * speed;
      var vy     = Math.sin(angle) * speed;
      var maxLife = 260 + Math.random() * 220;       /* 260–480 ms      */

      var x = originX + (Math.random() - 0.5) * 20;
      var y = originY + (Math.random() - 0.5) * 8;

      s.style.cssText = [
        'width:'  + size + 'px',
        'height:' + (size * (1.2 + Math.random() * 0.8)) + 'px',
        'left:'   + x + 'px',
        'top:'    + y + 'px',
        'background:' + color,
        'box-shadow:0 0 ' + (size * 1.8) + 'px ' + color,
        'opacity:1'
      ].join(';');

      var start = null;
      var GRAVITY = 40; /* px/s² */

      function tick(ts) {
        if (!start) start = ts;
        var elapsed = ts - start;
        var t = elapsed / maxLife;

        if (t >= 1) { releaseSpark(s); return; }

        var alpha = Math.pow(1 - t, 1.6);
        var dt    = 0.016; /* ≈ 60fps step */

        x += vx  * dt;
        y += (vy + GRAVITY * (elapsed / 1000)) * dt;

        s.style.left    = x + 'px';
        s.style.top     = y + 'px';
        s.style.opacity = alpha;
        s.style.transform = 'scale(' + (1 - t * 0.5) + ')';

        requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }, delay);
  }

  /* ---- Salve d'étincelles sur un élément ---- */
  function burst(el) {
    var rect  = el.getBoundingClientRect();
    var cx    = rect.left + rect.width  * 0.5;
    var cy    = rect.top  + rect.height * 0.45; /* légèrement au-dessus du centre */
    var count = 6 + Math.floor(Math.random() * 5); /* 6–10 étincelles */

    /* Toutes les étincelles dans les 180 ms → elles disparaissent avant ~480 ms
       → l'état de hover settled (fin de l'animation CSS ~340 ms) est propre */
    for (var i = 0; i < count; i++) {
      emitOne(cx, cy, i * (180 / count));
    }
  }

  /* ---- Sélecteurs cibles ---- */
  var SELECTORS = [
    '.site-nav__link',
    '.site-nav__dropdown a',
    '.mobile-nav__link',
    '.footer-content .nav-link-animated a',
    '.links-footer a',
    '.template-article__next-previous__info-link',
    '.breadcrumbs a',
    '.breadcrumb__link',
    '.rte a'
  ].join(',');

  /* ---- Attachement des listeners (délégation depuis body) ---- */
  document.addEventListener('mouseenter', function (e) {
    var target = e.target && e.target.closest && e.target.closest(SELECTORS);
    if (target) burst(target);
  }, true); /* capture phase pour intercepter avant les stopPropagation éventuels */

  /* ---- Actualisation après chargement dynamique (sections ajoutées par Shopify) ---- */
  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(function () { /* listeners déjà sur body, rien à faire */ });
    mo.observe(document.body, { childList: true, subtree: false });
  }
})();
